import { useEffect, useRef } from "react";
import { Moon } from "lucide-react";

export const CTA = () => {
  const sectionRef = useRef(null);
  const headlineRef = useRef(null);

  useEffect(() => {
    if (!window.gsap || !window.ScrollTrigger || !headlineRef.current) return;
    const gsapLib = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsapLib.registerPlugin(ScrollTrigger);

    gsapLib.fromTo(
      headlineRef.current,
      { scale: 0.8 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: { trigger: sectionRef.current, start: "top 85%", end: "top 30%", scrub: true },
      }
    );
  }, []);

  return (
    <section id="cta" ref={sectionRef} className="cosmic-section w-full text-center relative overflow-x-clip">
      <div className="glow-dot w-[420px] h-[420px] bg-[#A99BFF]/15 top-0 left-1/2 -translate-x-1/2" />
      <div className="max-w-4xl mx-auto relative z-10">
        <p className="reveal text-scrim cosmic-eyebrow text-sm mb-6">One Reading Away</p>
        <h2
          ref={headlineRef}
          data-testid="cta-headline"
          className="font-display text-scrim text-3xl sm:text-4xl lg:text-6xl text-[#F8ECC9] mb-8"
        >
          YOUR CHART IS WAITING
        </h2>
        <p className="reveal text-scrim font-accent italic text-lg text-[#F3EEE4] max-w-xl mx-auto mb-10">
          Every day you wait is a day the pattern stays unread. Let's open it together.
        </p>
        <a data-testid="cta-book-reading-button" href="#" className="reveal btn-gold">
          <span className="btn-content">
            <Moon size={16} />
            Book Your Reading
          </span>
        </a>
      </div>
    </section>
  );
};
